export { AtnDsEllipsisTooltipDirective as Directive } from './ellipsis-tooltip.directive'
